import React from 'react';
import { Play } from 'lucide-react';

const caseStudies = [
  {
    id: 1,
    title: 'Improving trade execution visibility',
    description: 'How a regional trading firm gained real-time intelligence across execution and risk.',
  }
];

const CaseStudies = () => {
  return (
    <section className="relative py-16 sm:py-20 lg:py-32 bg-slate-50 dark:bg-slate-950">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    
   
    <div className="mb-12 sm:mb-16 text-center">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 dark:text-white">
        How enterprises use TradeEngine.AI
      </h2>
    </div>

    {/* Centered Video Card */}
    <div className="flex justify-center">
      <div className="w-full max-w-4xl bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden shadow-sm">
        
        
        <div className="relative w-full aspect-video">
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src="https://www.youtube.com/embed/5fRtsHAeBS0"
            title=" AI Introduction"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

      
       

      </div>
    </div>

  </div>
</section>

  );
};

export default CaseStudies;
